export default "__VITE_ASSET__357709ad__"